import { defineMessages } from "react-intl";

export default defineMessages({
  header: {
    defaultMessage: "This is NotFoundPage component!",
    id: "app.components.NotFoundPage.header",
  },
});
